import React, { useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { VscChromeClose } from "react-icons/vsc";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const listLarge = (
    <ul className={`lg && hidden lg:flex 2xl:space-x-12 lg:space-x-4 xl:space-x-8 min-[1920px]:space-x-16`}>
      <li>
        <a href="#facilities" className="hover:text-blue-500">
          Fasilitas
        </a>
      </li>
      <li>
        <a href="#advantages" className="hover:text-blue-500">
          Keunggulan
        </a>
      </li>
      <li>
        <a href="#galleries" className="hover:text-blue-500">
          Galeri
        </a>
      </li>
      <li>
        <a href="#testimonies" className="hover:text-blue-500">
          Testimoni
        </a>
      </li>
      <li>
        <a href="#schedules" className="hover:text-blue-500">
          Jadwal
        </a>
      </li>
      <li>
        <a href="#articles" className="hover:text-blue-500">
          Artikel
        </a>
      </li>
    </ul>
  );

  const largeScreen = "lg";

  return (
    <header>
      <div className="flex items-center justify-between py-5 px-6  lg:flex lg:justify-between 2xl:py-6   lg:py-6  lg:h-18 lg:w-5/6 lg:mx-auto lg:p-0 ">
        <a href="#app">
          <img className="w-40 2xl:w-48" src="assets/logo.png" alt="" />
        </a>

        <div>
          {largeScreen && listLarge}

          {!menuOpen ? (
            <GiHamburgerMenu
              onClick={() => {
                setMenuOpen(!menuOpen);
              }}
              className="text-lg cursor-pointer lg:hidden "
              style={{
                color: "#1B5FC1",
              }}
            />
          ) : (
            <VscChromeClose
              onClick={() => {
                setMenuOpen(!menuOpen);
              }}
              className="text-lg cursor-pointer lg:hidden"
              style={{
                color: "#1B5FC1",
              }}
            />
          )}
        </div>
      </div>
      {menuOpen === false ? null : (
        <div className="z-[32] rounded-lg absolute bg-white w-full   text-sm grid grid-cols-1 divide-y lg:hidden ">
          <a href="#facilities" className="cursor-pointer py-2 px-5">
            Fasilitas
          </a>
          <a href="#advantages" className="cursor-pointer py-2 px-5">
            Keunggulan
          </a>
          <a href="#galleries" className="cursor-pointer py-2 px-5">
            Galeri
          </a>
          <a href="#testimonies" className="cursor-pointer py-2 px-5">
            Testimoni
          </a>
          <a href="#schedules" className="cursor-pointer py-2 px-5">
            Jadwal
          </a>
          <a href="#articles" className="cursor-pointer py-2 px-5">
            Artikel
          </a>
        </div>
      )}
    </header>
  );
}
